import EmptyState from "@/components/base/EmptyState";

interface Props {
  icon: string;
  title: string;
  description: string;
  hint?: string;
}

export default function ComingSoon({ icon, title, description, hint }: Props) {
  return (
    <div className="fr-animate space-y-5">
      <h1 className="text-[22px] font-bold text-foreground-950">{title}</h1>
      <div className="rounded-3xl border border-background-200/70 bg-background-50 shadow-card">
        <EmptyState icon={icon} title={title} description={description} />
      </div>
      {hint ? (
        <div className="flex items-start gap-2 rounded-2xl bg-secondary-50 p-3.5">
          <i className="ri-information-line mt-0.5 text-secondary-600" />
          <p className="text-[12px] leading-relaxed text-secondary-900">{hint}</p>
        </div>
      ) : null}
    </div>
  );
}